export default "__VITE_ASSET__02fzCVV___"